import { ampli } from "./generated/web";

export { ampli };
